import { render, staticRenderFns } from "./ShowRecoveryCodes.vue?vue&type=template&id=2681428b&"
import script from "./ShowRecoveryCodes.vue?vue&type=script&lang=js&"
export * from "./ShowRecoveryCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports